

function ImageContent({ typeContent }) {
    return (
        <div>
            {typeContent === "text" ?
                <img src="/image/icon/file/fileText.png" className="w-10 m-1" />
                :
                typeContent === "image" ?
                    <img src="/image/icon/file/filePhoto.png" className="w-10 m-1" />
                    :
                    typeContent === "video" ?
                        <img src="/image/icon/file/fileVideo.png" className="w-10 m-1" />
                        :
                        typeContent === "sound" ?
                            <img src="/image/icon/file/fileAudio.png" className="w-10 m-1" />
                            :
                            typeContent === "file" ?
                                <img src="/image/icon/file/fileOther.png" className="w-10 m-1" />
                                :
                                null
            }
        </div>
    )
}
export default ImageContent;